export default __webpack_public_path__ + "static/media/Regua.f16318f3.svg";